<template>
  <div
      class="my-3 col-lg-4 col-md-4 col-12"
  >
    <div>
      <label
          class="d-flex align-items-center my-1"
          :id="'string_' + field.id"
          :for="'string_' + field.id"
      >{{ field.fa_name }}
        <span v-if="field.status === fieldStatus.REQUIRED" class="text-danger">*</span>
      </label>
    </div>
    <input
        type="text"
        :disabled="!customer_style"
        class="form-control"
        :class="{'form-control light-input': customer_style}"
        :id="'string-' + field.id"
        :name="'string-' + field.id"
        :placeholder="(field.details && field.details.find(i => i.type === 'placeholder'))
          ? field.details.find(i => i.type === 'placeholder').data
          : ''"
        v-model="field.value"
        @input="validateField"
    />
    <small v-show="field.error" class="text-danger text-tiny">{{ error_value }}</small>
  </div>
</template>

<script>
import { fieldOptionsConstants } from '@/constants/CustomerFormatFieldOptions';

export default {
  name: 'StringInput',
  props: {
    field: {
      type: Object,
      required: true
    },
    customer_style: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      error_value: ''
    }
  },
  computed: {
    fieldStatus(){
      return fieldOptionsConstants
    },
  },
  methods: {
    validateField() {
      if (this.field.name.includes('mobile')) {
        const regex = /^09\d{9}$/;
        let isValid = regex.test(this.field.value)
        if (!isValid) {
          this.field.error = true
          this.error_value = 'شماره موبایل معتبر نمی باشد.'
          this.$emit('validate', { fieldId: this.field.id, isValid: false })
          return;
        }
      }

      if (this.field.status === this.fieldStatus.REQUIRED && !this.field.value) {
        this.field.error = true
        this.error_value = 'این فیلد اجباری می باشد.'
        this.$emit('validate', { fieldId: this.field.id, isValid: false })
        return;
      }

      this.field.error = false;
      this.$emit('validate', { fieldId: this.field.id, isValid: true });
    }
  },
};
</script>
<style scoped>
.light-input, .light-input::placeholder {
  background-color: ghostwhite !important;
  color: gray !important;
  border-color: #8c8a8a !important;
}
</style>